export function getInputClasses({ classes, caps, }) {
  const DEFAULT_CLASSES = `
    al-text-field__input
    ${caps ? 'al-text-field__input_caps' : ''}
  `;

  if (!classes) return DEFAULT_CLASSES;

  return `${DEFAULT_CLASSES} ${classes.join(' ')}`;
}